import React, {Component} from 'react';
import {connect} from 'react-redux';

import Utils from 'utils/Utils.js';
import {popAlert} from 'actions/alertModals.js';
import AlertModals from './AlertModals.js';


class AlertModalsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            waitToShowNextMessage: false, 
        };
        this.onClose = this.onClose.bind(this);
    }

    componentWillMount() {
    }

    onClose() {
        this.setState({waitToShowNextMessage:true}, 
            () => {
                this.props.popAlert(); 
                Utils.delay(1000).then(()=>{
                    this.setState({waitToShowNextMessage:false});
                });
            }
        );
    }

    render() {
        return (
            <AlertModals {...this.props} 
                         {...this.state}
                         onClose={this.onClose}/>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    var alerts = state.alertModals.alerts;
    var alert = (alerts.length > 0) ? alerts[0] : null;
    var open = Boolean(alert);
    return {...alert, open};
};

const mapDispatchToProps = (dispatch) => {
    return {
        popAlert: () => dispatch(popAlert()),
        dispatch: dispatch
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AlertModalsContainer);



// WEBPACK FOOTER //
// ./src/modules/alertmodal/AlertModalsContainer.js